import {
  Assignment,
  Autorenew,
  Cancel,
  CheckCircle,
  CompareArrows,
  Description,
  EmojiEvents,
  Grass,
  Schedule,
  Spa,
  WorkspacePremium,
} from '@mui/icons-material';
import type { KpiCardConfig } from './types';

export const KPI_CARD_CONFIGS: KpiCardConfig[] = [
  {
    key: 'totalRegisteredNurseries',
    label: 'Total Registered Nurseries',
    subtext: 'National total',
    accent: 'green',
    icon: <Grass fontSize="small" />,
  },
  {
    key: 'activePermits',
    label: 'Active Permits',
    subtext: 'National total',
    accent: 'orange',
    icon: <WorkspacePremium fontSize="small" />,
  },
  {
    key: 'newRegistration',
    label: 'New Registrations This Year',
    subtext: 'National total',
    accent: 'green',
    icon: <Assignment fontSize="small" />,
  },
  {
    key: 'renewalRegistration',
    label: 'Renewal Applications This Year',
    subtext: 'National total',
    accent: 'green',
    icon: <Autorenew fontSize="small" />,
  },
  {
    key: 'pendingApplication',
    label: 'Pending Applications',
    subtext: 'National total',
    accent: 'orange',
    icon: <Schedule fontSize="small" />,
  },
  {
    key: 'approvedApplication',
    label: 'Approved Applications',
    subtext: 'National total',
    accent: 'green',
    icon: <CheckCircle fontSize="small" />,
  },
  {
    key: 'rejectApplication',
    label: 'Rejected Applications',
    subtext: 'National total',
    accent: 'red',
    icon: <Cancel fontSize="small" />,
  },
  {
    key: 'certificatesIssued',
    label: 'Certificates Issued (CN02)',
    subtext: 'National total',
    accent: 'gold',
    icon: <EmojiEvents fontSize="small" />,
  },
  {
    key: 'totalSaleablePlants',
    label: 'Total Saleable Plants',
    subtext: 'All regions',
    accent: 'green',
    icon: <Spa fontSize="small" />,
  },
  {
    key: 'totalPlants',
    label: 'Total Plants Vs Saleable Plants',
    subtext: 'All regions',
    accent: 'teal',
    icon: <CompareArrows fontSize="small" />,
    comparison: {
      secondaryKey: 'totalSaleablePlants',
      percentageKey: 'saleablePlantsPercentage',
    },
  },
  {
    key: 'completedCn03',
    label: 'Completed CN3 Forms',
    subtext: 'National',
    accent: 'teal',
    icon: <Description fontSize="small" />,
  },
  {
    key: 'completedCn04',
    label: 'Completed CN4 Forms',
    subtext: 'National',
    accent: 'purple',
    icon: <Description fontSize="small" />,
  },
  {
    key: 'completedCn05',
    label: 'Completed CN5 Forms',
    subtext: 'National',
    accent: 'blue',
    icon: <Description fontSize="small" />,
  },
  {
    key: 'completedCn06',
    label: 'Completed CN6 Forms',
    subtext: 'National',
    accent: 'darkBlue',
    icon: <Description fontSize="small" />,
  },
];
